import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../config/api';
import { authFetch } from '../utils/authFetch';

export interface SpendingDistributionItem {
  name: string;
  value: number;
  [key: string]: any; // Index signature for recharts compatibility
}

export function useSpendingDistribution() {
  return useQuery<SpendingDistributionItem[]>({
    queryKey: ['spendingDistribution'],
    queryFn: async () => {
      const response = await authFetch(`${API_URL}/analytics/spending-distribution/`);
      if (!response.ok) throw new Error('Failed to fetch spending distribution');
      return response.json();
    },
  });
} 